import { DataGraphConstants } from "../../../Constants/DataGraphConstants";
import GraphType from "../../../Constants/GraphType";

import { RiPanelConstants } from "../../../Constants/RiPanelConstants";
import SettingsStore from "SettingsStore";
import datagraphHelper from "../../../Utils/DatagraphHelper";
const { ActionTypes } = RiPanelConstants;

const initialState = {
    zigzagIndicatorData: [],
    aiSettings: null,
    isShowZZIndicatorEditDialog: false,
    lineSettings: null,
    activePeriodLineSettings: null,
    majorPeriodicity: null,
    isZigzagAIEntitled: false,
    isTrackPriceAIVisible: false,
    zigZagResults: [],
    selectedSwingSize: 15,
    latestChange: 0, 
    percentile: {},
    duration: 0,
    declines: {},
    rallies: {},
    summary: {},
    zigzagHistory: {},
    swingSizeDeclines: {},
    swingSizeRallies: {},
    swingSizeSummaries: {},
    swingSizeZigzagHistoy: {},
    percentileLines: [],
    durationLines: [],
    isShowPercentileChange: true
}

const orderedKeys = [GraphType.Daily, GraphType.Weekly, GraphType.Monthly];
const getLineSettingsObj = (lineSettings) => {
    const orderedObject = {};
    orderedKeys.forEach((key) => {
        if (lineSettings[key]) {
            orderedObject[key] = JSON.parse(JSON.stringify(lineSettings[key]));
        }
    });

    return orderedObject;
}


const RiPanelAI = (state = initialState, action) => {
    switch (action.type) {

        case DataGraphConstants.ActionTypes.PRICE_PANEL_RESPONSE_READY:
            const consoleSettings = SettingsStore.getConsoleSettings();
            const aiSettings = datagraphHelper.getSettingsObject(consoleSettings, consoleSettings.NavDatagraphSettings.RelatedInformationSettings).AiSettings;
            return { ...state, aiSettings: aiSettings }

        case ActionTypes.ZZ_INDICATOR_DATA_READY:
            return { ...state, ...action.newState };

        case ActionTypes.UPDATE_ZZ_INDICATOR_SETTINGS:
            state.aiSettings.zigzagIndicator.isVisible = action.isVisible;
            SettingsStore.saveSettings();
            return { ...state };

        case ActionTypes.UPDATE_FUTURE_EVENT_SETTINGS:
            return { ...state, aiSettings: { ...action.aiSettings } };
        
        case ActionTypes.UPDATE_AI_SETTINGS:
            return { ...state, aiSettings: { ...action.aiSettings } };

        case ActionTypes.SHOW_ZZ_INDICATOR_EDIT_DIALOG:
            if (action.isSave) {
                state.aiSettings.zigzagIndicator.lineStyle[GraphType.Daily] = state.lineSettings[GraphType.Daily];
                state.aiSettings.zigzagIndicator.lineStyle[GraphType.Weekly] = state.lineSettings[GraphType.Weekly];
                state.aiSettings.zigzagIndicator.lineStyle[GraphType.Monthly] = state.lineSettings[GraphType.Monthly];
                SettingsStore.saveSettings();

                return { ...state, isShowZZIndicatorEditDialog: action.isShowZZIndicatorEditDialog, lineSettings: null, activePeriodLineSettings: state.aiSettings.zigzagIndicator.lineStyle[state.majorPeriodicity] };
            }
            else {
                const lineSettings = getLineSettingsObj(state.aiSettings.zigzagIndicator.lineStyle);

                return { ...state, isShowZZIndicatorEditDialog: action.isShowZZIndicatorEditDialog, lineSettings };
            }

        case ActionTypes.UPDATE_ZZ_INDICATOR_LINE_SETTINGS:
            {
                state.lineSettings[action.activePeriodicity][action.property] = action.value;

                return { ...state, lineSettings: Object.assign({}, state.lineSettings) };
            }

        case ActionTypes.RESTORE_ZZ_INDICATOR_LINE_SETTINGS:
            state.lineSettings[action.activePeriodicity].color = "PFFFFFF000000";
            state.lineSettings[action.activePeriodicity].weight = 2;
            return { ...state, lineSettings: Object.assign({}, state.lineSettings) };
        
        case ActionTypes.UPDATE_TRACK_PRICE_AI_SETTINGS:
            return { ...state,
                isTrackPriceAIVisible: action.isVisible,
             };

        case ActionTypes.AI_STATISTICS_DATA_READY:
            return { 
                ...state, 
                declines: action.declines, 
                rallies: action.rallies, 
                summary: action.summary,
                percentile: action.percentile,
                zigzagHistory: action.zigzagHistory,
                swingSizeRallies: action.swingSizeRallies,
                swingSizeDeclines: action.swingSizeDeclines,
                swingSizeSummaries: action.swingSizeSummaries,
                swingSizePercentiles: action.swingSizePercentiles,
                swingSizeZigzagHistoy: action.swingSizeZigzagHistoy,
                zigzagIndicatorData: action.zigzagIndicatorData,
            };
        case ActionTypes.TOGGLE_PERCENTILE_CHANGE:
            return { 
                ...state, 
                isShowPercentileChange: action.isShowPercentileChange,
            };

        default: return state;
    }
}

export default RiPanelAI;